import { useSelector } from "react-redux";

export default function useDeviceHms (deviceId) {
  const hms = useSelector(state => state.deviceService.deviceHms[deviceId]);
  return hms;
}